// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"3c491ac4","64":"f42ba7a2","112":"b75219f2","115":"9e9d3494","120":"1fa3daeb","248":"96f08752","384":"9a64f736","453":"f9868307","806":"11d23c25","969":"775db35c"}[chunkId] + ".chunk.js";
};